import React, { Fragment } from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"

import { event } from "./reactGA"

const Container = styled.div`
  background-color: #383d5a;
  border-radius: 8px;
  width: 100%;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 21%);
  padding: 12px;
  margin-top: 0;
  box-sizing: border-box;
`

const ExpansionPanelSummary = styled.div`
  padding: 8px 22px;
  box-sizing: border-box;
  height: 52px;
  align-items: center;
  justify-content: space-between;
  display: flex;
  border-radius: 6px;
  color: #fff;
`

const ExpansionPanelDetails = styled.div`
  margin-top: 32px;
`

const Text = styled.span`
  font-family: "montserratLight";
  font-size: 14px;
`

class ExpenisonPanelView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isExpand: false,
    }
    this.onChange = this.onChange.bind(this)
  }

  onChange() {
    const { readEvent, unReadEvent } = this.props
    this.setState({
      isExpand: !this.state.isExpand,
    })
    console.log("Home Page")
    event({
      category: "Home Page",
      action: this.state.isExpand ? unReadEvent : readEvent,
    })
    this.props.bidValue && this.props.onClick()
  }

  render() {
    const { children, title, theme } = this.props
    const { isExpand } = this.state

    const panelStyle1 =
      this.props.bidValue && this.props.activeClass === "activeBid"
        ? {
            height: "26px",
            margin: 0,
            borderRadius: "18px",
            // backgroundColor: "#353746",
            backgroundColor: theme.secondaryColor,
            padding: "12px",
            fontSize: "14px",
            backgroundColor: "#aa50ff",
          }
        : this.props.bidValue
        ? {
            height: "26px",
            margin: 0,
            borderRadius: "18px",
            padding: "12px",
            fontSize: "14px",
            backgroundColor: theme.secondaryColor,
          }
        : {}

    const panelStyle2 = isExpand
      ? { backgroundColor: theme.primaryColor }
      : { backgroundColor: theme.secondaryColor }
    return (
      <Fragment>
        <Container
          style={
            this.props.bidValue
              ? {
                  width: "70px",
                  padding: 0,
                  borderRadius: "18px",
                  // backgroundColor: "#353746",
                  backgroundColor: theme.cardColor,
                  margin: "8px",
                }
              : {
                  backgroundColor: theme.cardColor,
                }
          }
        >
          <ExpansionPanelSummary
            onClick={this.onChange}
            style={{ ...panelStyle1, ...panelStyle2 }}
            className={
              isExpand ? "panel_summary_active" : "panel_summary_inactive"
            }
          >
            <Text>{title}</Text>
            <ExpandMoreIcon
              style={{
                transform: isExpand ? "rotate(180deg)" : "rotate(0deg)",
                fontSize: "18px",
                opacity: " 0.7",
              }}
            />
          </ExpansionPanelSummary>
        </Container>
        {isExpand && <ExpansionPanelDetails>{children}</ExpansionPanelDetails>}
      </Fragment>
    )
  }
}

ExpenisonPanelView.propTypes = {
  children: PropTypes.node,
  readEvent: PropTypes.string,
  unReadEvent: PropTypes.string,
  title: PropTypes.string,
}

export default ExpenisonPanelView



// WEBPACK FOOTER //
// ./src/components/ExpenisonPanel.js